"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PetitionsGraphQLService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
class PetitionsGraphQLService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.getPetitions = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionsList, variables, options, requestOptions);
      return response.data.petitions.list;
    });
    this.getPetitionTemplates = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.listPetitionTemplates, variables, options, requestOptions);
      return response.data.petitions.listPetitionTemplates;
    });
    this.getPetitionsListFilters = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionsListFilters, {}, options, requestOptions);
      return response.data.petitions.filters;
    });
    this.getPetitionsListHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionsListHistory, variables, options, requestOptions);
      return response.data.petitions.history;
    });
    this.getPetitionHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionHistory, variables, options, requestOptions);
      return response.data.petitions.petition.history;
    });
    this.getPetition = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionQuery, variables, options, requestOptions);
      return response.data.petitions.petition.petition;
    });
    this.getPetitionAppeals = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionAppeals, variables, options, requestOptions);
      return response.data.petitions.petition.petitionAppeals;
    });
    this.getPetitionFilters = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionFilters, variables, options, requestOptions);
      return response.data.petitions.petition.filters;
    });
    this.getPetitionMySignature = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionMySignature, variables, options, requestOptions);
      return response.data.petitions.petition.mySignature;
    });
    this.getPetitionSignatures = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionSignatures, variables, options, requestOptions);
      return response.data.petitions.petition.signatures;
    });
    this.getPetitionStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionStatistics, variables, options, requestOptions);
      return response.data.petitions.petition.statistic;
    });
    this.createPetition = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionsCreate, variables, options, requestOptions);
      return response.data.petitions.create;
    });
    this.editPetition = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionEdit, variables, options, requestOptions);
      return response.data.petitions.petition.edit;
    });
    this.deletePetition = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionDelete, variables, options, requestOptions);
      return response.data.petitions.petition.delete;
    });
    this.publishPetition = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionPublish, variables, options, requestOptions);
      return response.data.petitions.petition.publish;
    });
    this.createPetitionFromTemplate = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionsCreateFromTemplate, variables, options, requestOptions);
      return response.data.petitions.createFromTemplate;
    });
    this.updatePetitionFromTemplate = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionsUpdateFromTemplate, variables, options, requestOptions);
      return response.data.petitions.petition.updateFromTemplate;
    });
    this.sendPetitionUniqueRegistryLinks = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendPetitionRegistryUniqueLinks, variables, options, requestOptions);
      return response.data.petitions.petition.sendRegistryUniqueLinks;
    });
    this.sendPetitionDocuments = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendPetitionDocuments, variables, options, requestOptions);
      return response.data.petitions.petition.sendDocuments;
    });
    this.petitionRefuse = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionRefuse, variables, options, requestOptions);
      return response.data.petitions.petition.mySignature.refuse;
    });
    this.petitionRevoke = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionRevoke, variables, options, requestOptions);
      return response.data.petitions.petition.mySignature.revoke;
    });
    this.finishPetition = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.petitionFinish, variables, options, requestOptions);
      return response.data.petitions.petition.finish;
    });
    this.comment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.signatureComment, variables, options, requestOptions);
      return response.data.petitions.petition.mySignature.comment;
    });
  }
}
exports.PetitionsGraphQLService = PetitionsGraphQLService;
const petitionsGraphQLService = new PetitionsGraphQLService();
exports.default = petitionsGraphQLService;